import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { PeopleIdItem, PeoplePersonItem } from '../-types';

/**
 * People テーブルのカラム定義
 */
export const PeopleTableColumns = {
  PERSON: 'PERSON',
  IDS: 'IDS'
} as const;
export type PeopleTableColumns = EnumUnion<typeof PeopleTableColumns>;

/**
 * テーブル表示用のPerson型（nameInitialsを追加）
 */
export type PeopleTablePersonItem = PeoplePersonItem & {
  nameInitials: string;
};

/**
 * People テーブルの行データ型
 */
export type PeopleTableRow = {
  [PeopleTableColumns.PERSON]: PeopleTablePersonItem | null;
  [PeopleTableColumns.IDS]: PeopleIdItem[];
};